import useSchools from './useSchools';
import useUploadProgress from './useUploadProgress';
import { useDataQcOutletContext } from './useDataQcOutletContext';

function useCategoryUploadState(categoryName: string) {
  const { uploadProgress, schools } = useDataQcOutletContext();
  const { schoolsUploadProgressByCategory } = useUploadProgress();
  const { dataQcSchool } = useSchools();

  const getCardState = () => {
    // SKIP UPLOADED DATA CHECKS - TO DELETE
    let skip = true;
    if (skip) return true;

    if (!categoryName) return true;
  
    if (!dataQcSchool) {
      if (categoryName === 'Matching') return uploadProgress.completed.length >= 1;
  
      return Boolean(uploadProgress.completed.find((category) => category.categoryName === categoryName));
    }
  
    const schoolData = schools.find(school => school.id === dataQcSchool);
    if (!schoolData) return false;
  
    if (categoryName === 'Matching') {
      let schoolsProgresses = Object.values(schoolsUploadProgressByCategory);
      let areCategoriesCompleted = schoolsProgresses.some(schoolProgress => schoolProgress[schoolData.name] === 'completed');
  
      return areCategoriesCompleted;
    }

    let schoolProgressInCategory = schoolsUploadProgressByCategory[categoryName];
    if (!schoolProgressInCategory || !(schoolData.name in schoolProgressInCategory)) {
      throw new Error(`Upload progress for ${categoryName} is unavailable!`);
    }
    return schoolProgressInCategory[schoolData.name] === 'completed';
  };

  return getCardState();
}

export default useCategoryUploadState;